// Shuffle array utility using Fisher-Yates algorithm
import { randomIndex } from './randomSelection';
/**
 * Shuffle an array using the Fisher-Yates algorithm
 * This provides a uniform random distribution, unlike .sort(() => Math.random() - 0.5)
 *
 * @param array - The array to shuffle
 * @returns A new shuffled array (does not mutate the original)
 */
export function shuffleArray(array) {
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
        const j = randomIndex(i + 1);
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
}
//# sourceMappingURL=shuffleArray.js.map